
import Vue from 'vue';
import { BoardViewMode } from '../types';
import BaseGreyToggleButton from '@/components/base/BaseGreyToggleButton.vue';

export default Vue.extend({
	name: 'ViewModeToggle',
	components: {
		BaseGreyToggleButton,
	},
	props: {
		value: {
			type: String,
			required: true,
			validator: (value: string) => Object.values(BoardViewMode).includes(value as BoardViewMode),
		},
	},
	data() {
		return {
			BoardViewMode,
		};
	},
	computed: {
		toggleOptions () {
			return [
				{ value: BoardViewMode.GRID, icon: 'mdi-view-dashboard-outline' },
				{ value: BoardViewMode.TABLE, icon: 'mdi-table-large' },
			];
		},
	},
});
